/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AWSNotification = {
    Type: AWSNotification.Type;
    MessageId: string;
    TopicArn: string;
    Message: string;
    Timestamp: string;
    SignatureVersion: string;
    Signature: string;
    SigningCertURL: string;
    SubscribeURL?: string;
    Token?: string;
    Subject?: string;
};
export namespace AWSNotification {
    export enum Type {
        SUBSCRIPTION_CONFIRMATION = 'SubscriptionConfirmation',
        UNSUBSCRIBE_CONFIRMATION = 'UnsubscribeConfirmation',
        NOTIFICATION = 'Notification',
    }
}

